import ViktorClient from '@/api/clients/viktorClient/ViktorClient';

import type {
  FileDownloadResponse,
  TeamAnalysisExportPayload,
  TeamAnalysisReportPayload
} from './teamAnalysisExport.types';

export function postTeamAnalysisExportGenerate(payload: TeamAnalysisExportPayload): Promise<void> {
  return ViktorClient().post('/team-analysis/export/generate', payload);
}

export function postTeamAnalysisReportGenerate(payload: TeamAnalysisReportPayload): Promise<void> {
  return ViktorClient().post('/team-analysis/report/generate', payload);
}

export function getTeamAnalysisExportFile(filename: string): Promise<FileDownloadResponse> {
  return ViktorClient().get(`/team-analysis/export/${filename}`, {
    responseType: 'blob'
  });
}

export function getTeamAnalysisReportFile(filename: string): Promise<FileDownloadResponse> {
  return ViktorClient().get(`/team-analysis/report/${filename}`, {
    responseType: 'blob'
  });
}
